
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/traffic/information",
      function () {
        return require("private-next-pages/traffic/information/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/traffic/information"])
      });
    }
  